import { useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

export function useAttachments(apiUrl, token, initial = []) {
  const [attachments, setAttachments] = useState(
    initial.map((a) => ({ ...a, id: uuidv4() }))
  );

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(
        `${apiUrl}/api/news/upload-attachment`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setAttachments((prev) => {
        if (prev.length >= 6) return prev;
        return [
          ...prev,
          {
            id: uuidv4(),
            url: res.data.url,
            mime: res.data.mime,
          },
        ];
      });
    } catch (err) {
      console.error("Ошибка при загрузке файла вложения:", err);
    }
  };

  const removeAttachment = (id) =>
    setAttachments((prev) => prev.filter((att) => att.id !== id));

  const reorder = (from, to) => {
    setAttachments((prev) => {
      const arr = [...prev];
      const [m] = arr.splice(from, 1);
      arr.splice(to, 0, m);
      return arr;
    });
  };

  return { attachments, setAttachments, uploadFile, removeAttachment, reorder };
}
